import React from 'react';
import { Card, CardContent, Typography, Box, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface DashboardCardProps {
  title: string;
  value: number | string;
  icon: React.ReactNode;
  onClick?: () => void;
  color?: string;
  isText?: boolean;
}

const DashboardCard: React.FC<DashboardCardProps> = ({ 
  title, 
  value, 
  icon, 
  onClick, 
  color = '#1E3A8A',
  isText = false 
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const formatValue = () => {
    if (isText) {
      return value;
    }
    if (typeof value === 'number') {
      return value.toLocaleString();
    }
    return value;
  };

  return (
    <Card
      sx={{
        cursor: onClick ? 'pointer' : 'default',
        background: `linear-gradient(135deg, ${color}15 0%, ${color}08 100%)`,
        border: `1px solid ${color}20`,
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: onClick ? 'translateY(-4px)' : 'none',
          boxShadow: onClick ? `0 8px 25px ${color}25` : 'none',
          borderColor: onClick ? color : `${color}20`,
        },
      }}
      onClick={handleClick}
    >
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Typography variant="h6" sx={{ color: '#1E3A8A', fontWeight: 600 }}>
            {title}
          </Typography>
          <Box
            sx={{
              p: 1,
              borderRadius: 2,
              background: `linear-gradient(135deg, ${color} 0%, ${color}DD 100%)`,
              color: '#FFFFFF',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {icon}
          </Box>
        </Box>
        <Typography 
          variant={isText ? "h5" : "h3"} 
          sx={{ 
            color: '#1E3A8A', 
            fontWeight: 700, 
            textAlign: 'center',
            textTransform: isText ? 'capitalize' : 'none'
          }}
        >
          {formatValue()}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default DashboardCard; 